<div class="ufla">
  <ufla-westnetz-page>
    <div class="page-area">
      <ufla-navigation-header></ufla-navigation-header>
      <router-outlet class="main-area"></router-outlet>
    </div>
    <ufla-westnetz-footer class="footer-area"></ufla-westnetz-footer>
  </ufla-westnetz-page>
</div>
